import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=cc303284&scoped=true"
import script from "./ContactsView.vue?vue&type=script&lang=js"
export * from "./ContactsView.vue?vue&type=script&lang=js"
import style0 from "./ContactsView.vue?vue&type=style&index=0&id=cc303284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc303284",
  null
  
)

export default component.exports